import React from 'react';
import SessionItem from './SessionItem';

const getTimeGroup = (session) => {
  if (!session.created_at && !session.updated_at) return 'Older';
  const date = new Date(session.updated_at || session.created_at);
  const now = new Date();
  const diffMs = now - date;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays === 0 && now.getDate() === date.getDate()) return 'Today';
  if (diffDays <= 1 && now.getDate() - date.getDate() === 1) return 'Yesterday';
  if (diffDays < 7) return 'This Week';
  return 'Older';
};

const groupSessions = (sessions) => {
  const groups = { Today: [], Yesterday: [], 'This Week': [], Older: [] };
  sessions.forEach(session => {
    const group = getTimeGroup(session);
    groups[group].push(session);
  });
  return groups;
};

const SessionList = ({ sessions, currentSessionId, onSelectSession, onDeleteSession }) => {
  if (!sessions || sessions.length === 0) {
    return (
      <div id="session-list" className="flex-1 overflow-y-auto p-2">
        <div
          className="session-item flex items-center p-3 rounded-lg mb-1 cursor-pointer text-gray-700 hover:bg-gray-100 active"
          onClick={() => onSelectSession(null)}
        >
          <div className="session-content flex-1 min-w-0">
            <div className="session-title text-sm font-medium truncate">New Chat</div>
          </div>
        </div>
      </div>
    );
  }

  const groups = groupSessions(sessions);
  const groupOrder = ['Today', 'Yesterday', 'This Week', 'Older'];

  return (
    <div id="session-list" className="flex-1 overflow-y-auto p-2">
      {groupOrder.map((groupName, gi) => {
        const groupSessions = groups[groupName];
        if (groupSessions.length === 0) return null;
        return (
          <div key={groupName} className={gi > 0 ? 'border-t border-gray-100' : ''}>
            <div className="px-3 pt-3 pb-1">
              <span className="text-xs font-medium text-gray-400 uppercase tracking-wider">{groupName}</span>
            </div>
            {groupSessions.map((session, index) => (
              <SessionItem
                key={session.id}
                session={session}
                isActive={session.id === currentSessionId}
                isFirst={index === 0}
                onClick={() => onSelectSession(session.id)}
                onDelete={() => onDeleteSession(session.id)}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default SessionList;
